import script from "./RequestComic.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestComic.vue?vue&type=script&setup=true&lang=js"

import "@/features/comic/styles/RequestComic.css?vue&type=style&index=0&id=827384de&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-827384de"]])

export default __exports__